import { Injectable, ApplicationRef, inject } from '@angular/core';
// import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { AlertController } from '@ionic/angular/standalone';
import { concat, interval } from 'rxjs';
import { first, filter } from 'rxjs/operators';

/**
 * Service de gestion des mises à jour PWA via Angular Service Worker
 * Remplace le système de polling version.json par le mécanisme ngsw intégré
 */
@Injectable({
  providedIn: 'root'
})
export class PwaUpdateService {
  private appRef = inject(ApplicationRef);
  // private swUpdate = inject(SwUpdate);
  private alertController = inject(AlertController);

  constructor() {
    // Nettoyage des anciens service workers et caches au démarrage
    // this.cleanupOldServiceWorkers();
  }

  /**
   * Démarre les vérifications périodiques de mise à jour
   * Vérification toutes les 5 minutes en production
   */
  startUpdateChecks() {
    return;
    // if (!this.swUpdate.isEnabled) {
    //   console.warn('[PWA Update] ⚠️ Service worker NON ACTIVÉ');
    //   console.warn('[PWA Update] Raisons possibles:');
    //   console.warn('[PWA Update] - Mode développement (isDevMode = true)');
    //   console.warn('[PWA Update] - Navigateur non compatible');
    //   console.warn('[PWA Update] - Build sans --configuration=production ou --configuration=qa');
    //   console.warn('[PWA Update] Solution: npm run build:qa ou build en production');
    //   return;
    // }

    console.log('[PWA Update] ✅ Service de mise à jour ACTIVÉ');
    console.log('[PWA Update] 🔍 Vérification toutes les 5 minutes');

    // S'abonner aux événements de version
    this.subscribeToVersionUpdates();

    // Vérification périodique toutes les 5 minutes
    const appIsStable$ = this.appRef.isStable.pipe(
      first((isStable) => isStable === true)
    );
    const everyFiveMinutes$ = interval(5 * 60 * 1000); // Production: 5 minutes
    const periodicCheck$ = concat(appIsStable$, everyFiveMinutes$);

    // periodicCheck$.subscribe(async () => {
    //   try {
    //     const now = new Date().toLocaleTimeString();
    //     console.log(`[PWA Update] 🔍 Vérification à ${now}...`);

    //     const updateFound = await this.swUpdate.checkForUpdate();
    //     if (updateFound) {
    //       console.log('[PWA Update] ✅ NOUVELLE VERSION DÉTECTÉE!');
    //     } else {
    //       console.log('[PWA Update] ℹ️ Application à jour (pas de nouvelle version)');
    //     }
    //   } catch (error) {
    //     console.error('[PWA Update] ❌ Erreur lors de la vérification:', error);
    //   }
    // });
  }

  /**
   * S'abonne aux événements de mise à jour du service worker
   */
  private subscribeToVersionUpdates() {
    console.log('[PWA Update] 🎧 Abonnement aux événements de version...');

    // // Événement principal: nouvelle version prête à être activée
    // this.swUpdate.versionUpdates
    //   .pipe(filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY'))
    //   .subscribe(async (evt) => {
    //     console.log('[PWA Update] 🎉 VERSION_READY!');
    //     console.log('[PWA Update] 📦 Version actuelle:', evt.currentVersion.hash);
    //     console.log('[PWA Update] 🆕 Nouvelle version:', evt.latestVersion.hash);

    //     await this.promptUpdate(evt.latestVersion.hash);
    //   });

    // // Logs pour les autres événements
    // this.swUpdate.versionUpdates.subscribe((evt) => {
    //   switch (evt.type) {
    //     case 'VERSION_DETECTED':
    //       console.log('[PWA Update] 🔍 VERSION_DETECTED - Téléchargement en cours...', evt.version.hash);
    //       break;
    //     case 'VERSION_INSTALLATION_FAILED':
    //       console.error('[PWA Update] ❌ VERSION_INSTALLATION_FAILED:', evt.error);
    //       break;
    //     case 'NO_NEW_VERSION_DETECTED':
    //       console.log('[PWA Update] ℹ️ NO_NEW_VERSION_DETECTED - Serveur a la même version');
    //       break;
    //   }
    // });

    // // Événements non versionnés (errors, etc.)
    // this.swUpdate.unrecoverable.subscribe(event => {
    //   console.error('[PWA Update] ❌ Erreur irrécupérable du service worker:', event.reason);
    //   // Optionnel: proposer un rechargement complet
    //   this.promptUnrecoverableError();
    // });
  }

  /**
   * Affiche une alerte pour proposer la mise à jour
   * Maintient l'UX actuelle avec les mêmes textes en français
   */
  private async promptUpdate(newVersionHash: string) {
    const alert = await this.alertController.create({
      header: 'Mise à jour disponible',
      message: 'Une nouvelle version de La BASE est disponible. Rechargez l\'application pour profiter des dernières améliorations.',
      backdropDismiss: false,
      buttons: [
        {
          text: 'Plus tard',
          role: 'cancel',
          cssClass: 'alert-button-cancel',
          handler: () => {
            console.log('[PWA Update] Mise à jour reportée par l\'utilisateur');
          }
        },
        {
          text: 'Mettre à jour',
          cssClass: 'alert-button-confirm',
          handler: () => {
            this.activateUpdate();
          }
        }
      ]
    });

    await alert.present();
  }

  /**
   * Active la nouvelle version et recharge l'application
   * NGSW gère automatiquement le nettoyage des anciens caches
   */
  private async activateUpdate() {
    try {
      console.log('[PWA Update] 🔄 Activation de la nouvelle version...');

      // Activer la nouvelle version du service worker
      // await this.swUpdate.activateUpdate();

      console.log('[PWA Update] ✅ Nouvelle version activée, rechargement...');

      // Recharger la page pour utiliser la nouvelle version
      // Note: contrairement à version-check.service, pas besoin de vider les caches manuellement
      // NGSW gère cela automatiquement via son système de hash de version
      window.location.reload();
    } catch (error) {
      console.error('[PWA Update] ❌ Erreur lors de l\'activation:', error);

      // Fallback: forcer le rechargement quand même
      window.location.reload();
    }
  }

  /**
   * Gère les erreurs irrécupérables du service worker
   */
  private async promptUnrecoverableError() {
    const alert = await this.alertController.create({
      header: 'Erreur de l\'application',
      message: 'Une erreur critique s\'est produite. L\'application doit être rechargée.',
      backdropDismiss: false,
      buttons: [
        {
          text: 'Recharger',
          cssClass: 'alert-button-confirm',
          handler: () => {
            window.location.reload();
          }
        }
      ]
    });

    await alert.present();
  }

  /**
   * Vérification manuelle de mise à jour
   * Peut être appelée depuis un bouton dans l'interface
   */
  async checkNow(): Promise<boolean> {
    // if (!this.swUpdate.isEnabled) {
    //   console.warn('[PWA Update] Service worker non activé');
    //   return false;
    // }

    try {
      console.log('[PWA Update] 🔍 Vérification manuelle...');
      const updateAvailable = true//await this.swUpdate.checkForUpdate();

      if (updateAvailable) {
        console.log('[PWA Update] ✅ Mise à jour disponible');
      } else {
        console.log('[PWA Update] ℹ️ Application à jour');
      }

      return updateAvailable;
    } catch (error) {
      console.error('[PWA Update] ❌ Erreur lors de la vérification manuelle:', error);
      return false;
    }
  }

  /**
   * Nettoie les anciens service workers et caches
   * Supprime le service-worker.js manuel et le cache labase-v1
   * Exécuté une seule fois au démarrage après migration
   */
  private async cleanupOldServiceWorkers() {
    try {
      // Supprimer les anciennes registrations de service worker
      const registrations = await navigator.serviceWorker.getRegistrations();

      for (const registration of registrations) {
        const scriptUrl = registration.active?.scriptURL || '';

        // Supprimer l'ancien service-worker.js manuel (pas ngsw-worker.js ou OneSignal)
        if (scriptUrl.includes('service-worker.js') && !scriptUrl.includes('ngsw-worker.js')) {
          await registration.unregister();
          console.log('[PWA Update] 🧹 Ancien service worker supprimé:', scriptUrl);
        }
      }

      // Supprimer les anciens caches (labase-v1, etc.)
      const cacheNames = await caches.keys();

      for (const cacheName of cacheNames) {
        // Supprimer les caches qui commencent par 'labase-v' (anciens caches manuels)
        // Ne pas toucher aux caches ngsw:
        if (cacheName.startsWith('labase-v')) {
          await caches.delete(cacheName);
          console.log('[PWA Update] 🧹 Ancien cache supprimé:', cacheName);
        }
      }
    } catch (error) {
      console.error('[PWA Update] ⚠️ Erreur lors du nettoyage:', error);
      // Non bloquant - l'application continue de fonctionner
    }
  }
}
